import { Cart, CartEvents, CartEventsEnum, CartEventsVersionsEnum } from '@commerce-cart-webcomponents/sdk';
import { ProductEvents, ProductEventsEnum } from '@commerce-product-webcomponents/sdk';
import { Button, ButtonStyles, ButtonWidth, Theme, useTranslation } from '@nextgen-web-framework/all';
import { useEffect, useState } from 'react';
import { ButtonLoader } from '../ButtonLoader/ButtonLoader';
import styles from './AddToCartButton.module.scss';
import { type AddToCartButtonPropTypes } from './types/propsTypes';

const AddToCartButton = ({
  onProductAddedCb,
  entryObj,
  disabled = false,
  size,
  addToCartButtonType,
}: AddToCartButtonPropTypes) => {
  const t = useTranslation();
  const addToCartButtonText = t('product.addToCartButton.addToCart');
  const [showLoader, setShowLoader] = useState(false);

  const createPayload = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => ({
    onProductAdded: (value: Cart) => onProductAddedCb?.(e, value),
    entryObj,
    addToCartButtonType,
  });

  const publishEvent = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    ProductEvents.publishEvent({
      event: ProductEventsEnum.AddToCartBtnClick,
      payload: createPayload(e),
    });
  };

  useEffect(() => {
    const showLoaderEvent = CartEvents.subscribeEvents({
      topics: [CartEventsEnum.ShowLoader],
      version: CartEventsVersionsEnum['1.0.0'],
      cb: () => {
        setShowLoader(true);
      },
    });

    const hideLoaderEvent = CartEvents.subscribeEvents({
      topics: [CartEventsEnum.HideLoader],
      version: CartEventsVersionsEnum['1.0.0'],
      cb: () => {
        setShowLoader(false);
      },
    });

    return () => {
      CartEvents.unsubscribe([showLoaderEvent, hideLoaderEvent]);
    };
  }, []);

  return (
    <div className={`${styles['add-to-cart-container']}`} data-testid="add-to-cart-container">
      <div className={styles['container']}>
        {showLoader && <ButtonLoader size={size} className={styles['button-loader']} />}
        <Button
          id={'add-to-cart-button'}
          onClick={publishEvent}
          buttonWidth={ButtonWidth.FULL_WIDTH}
          title={addToCartButtonText}
          buttonStyle={ButtonStyles.SOLID}
          theme={Theme.BLACK}
          size={size}
          tabIndex={0}
          disabled={disabled}
          aria-label="Add to Cart Button"
          data-testid={'add-to-cart-button'}
        />
      </div>
    </div>
  );
};

export default AddToCartButton;
export type { AddToCartButtonPropTypes };
